(function () {
  'use strict';

  var section = document.querySelector('[data-session-flow]');
  if (!section) return;

  var path = section.querySelector('.lp3-session-flow__graph-path');
  var svg = section.querySelector('.lp3-session-flow__graph');
  var pin = section.querySelector('.lp3-session-flow__pin');
  var dot = section.querySelector('.lp3-session-flow__dot');
  var dotHalo = section.querySelector('.lp3-session-flow__dot-halo');
  var hudVitals = section.querySelector('.lp3-session-flow__hud-vitals');
  var hudTime = section.querySelector('[data-hud-time]');
  var hudBpm = section.querySelector('[data-hud-bpm]');
  if (!path || !svg || !pin || !dot || !dotHalo || !hudVitals || !hudTime) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var viewBoxWidth = svg.viewBox.baseVal.width;

  var totalLength = path.getTotalLength();
  path.style.strokeDasharray = totalLength;
  path.style.strokeDashoffset = totalLength;

  if (reduceMotion) {
    path.style.strokeDashoffset = 0;
    return;
  }

  // Precompute samples along the path once: local (viewBox-space) x/y at
  // each length, so we can look up "which length is at a given local y"
  // without an expensive per-frame search over the raw path geometry.
  var SAMPLE_COUNT = 400;
  var samples = [];
  for (var i = 0; i <= SAMPLE_COUNT; i++) {
    var len = (totalLength * i) / SAMPLE_COUNT;
    var pt = path.getPointAtLength(len);
    samples.push({ length: len, x: pt.x, y: pt.y });
  }

  // The path's own y-range (not the SVG viewBox bounds) is what "start"
  // and "end" of the drawable line actually mean, since the path data
  // starts above y=0 (e.g. y=-78) and can end past viewBoxHeight.
  var pathStartY = samples[0].y;
  var pathEndY = samples[samples.length - 1].y;

  var KEYFRAMES = [
    { progress: 0.10, time: '02:14', bpm: 98, temp: 38.2 },
    { progress: 0.30, time: '05:38', bpm: 132, temp: 40.7 },
    { progress: 0.48, time: '07:12', bpm: 118, temp: 40.3 },
    { progress: 0.62, time: '08:02', bpm: 74, temp: 38.9 },
    { progress: 0.82, time: '10:21', bpm: 88, temp: 37.8 }
  ];

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function getHudValues(progress) {
    if (progress <= KEYFRAMES[0].progress) {
      return KEYFRAMES[0];
    }
    if (progress >= KEYFRAMES[KEYFRAMES.length - 1].progress) {
      return KEYFRAMES[KEYFRAMES.length - 1];
    }
    for (var i = 0; i < KEYFRAMES.length - 1; i++) {
      var a = KEYFRAMES[i];
      var b = KEYFRAMES[i + 1];
      if (progress >= a.progress && progress <= b.progress) {
        var t = (progress - a.progress) / (b.progress - a.progress);
        return {
          time: t < 0.5 ? a.time : b.time,
          bpm: Math.round(lerp(a.bpm, b.bpm, t)),
          temp: lerp(a.temp, b.temp, t)
        };
      }
    }
    return KEYFRAMES[0];
  }

  // Find the furthest-along sample whose y has not yet passed targetY,
  // approximating "the point on the path currently level with targetY"
  // for a path that trends downward with local wiggles.
  function findSampleForY(targetY) {
    var best = samples[0];
    for (var i = 0; i < samples.length; i++) {
      if (samples[i].y <= targetY) {
        best = samples[i];
      } else {
        break;
      }
    }
    return best;
  }

  // グラフ自体をCSS(transform: scale)で物理的に拡大しているため、
  // 同じ距離をスクロールしたときの進みは自然に遅くなる。ここでは
  // 速いフリックの際にガクッと飛ばないよう、軽いeasingだけ加える。
  // 目標値(実際に画面中央にある点)は毎フレーム変わらず正しく計算するので、
  // 表示値がそこへ追いつけば必ず実際の線・画面中央と一致する。
  var EASE = 0.18;

  var displayedLength = 0;
  var displayedInitialized = false;

  function render() {
    var svgRect = svg.getBoundingClientRect();
    var scale = svgRect.width / viewBoxWidth;
    if (!scale) return;

    var viewportCenterY = window.innerHeight * 0.5;
    var localTargetY = (viewportCenterY - svgRect.top) / scale;

    var withinRange = localTargetY >= pathStartY && localTargetY <= pathEndY;

    var clampedY = localTargetY;
    if (clampedY < pathStartY) clampedY = pathStartY;
    if (clampedY > pathEndY) clampedY = pathEndY;

    var targetSample = findSampleForY(clampedY);

    if (!displayedInitialized) {
      displayedLength = targetSample.length;
      displayedInitialized = true;
    } else {
      displayedLength = lerp(displayedLength, targetSample.length, EASE);
    }

    var displayedPt = path.getPointAtLength(displayedLength);

    path.style.strokeDashoffset = totalLength - displayedLength;

    pin.classList.toggle('is-visible', withinRange);

    var xPx = svgRect.left + displayedPt.x * scale;
    dot.style.left = xPx + 'px';
    dotHalo.style.left = xPx + 'px';

    // 画面端からはみ出さないよう、DOTが右半分にあるときはHUDを左側(内側)に出す。
    var dotNearRightEdge = xPx > window.innerWidth / 2;

    hudVitals.style.left = xPx + 'px';
    hudVitals.classList.toggle('is-right', dotNearRightEdge);

    var progress = displayedLength / totalLength;
    var values = getHudValues(progress);
    hudTime.textContent = values.time;
    if (hudBpm) hudBpm.textContent = values.bpm;
  }

  // easingで滑らかに追従させるため、スクロール中に限らず常時rAFで更新する。
  function loop() {
    render();
    window.requestAnimationFrame(loop);
  }

  window.requestAnimationFrame(loop);
})();
